import { jsx as _jsx } from "react/jsx-runtime";
import React, { isValidElement } from 'react';
import { CircularProgress } from '@mui/material';
import clsx from 'clsx';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
var renderSwitcherIcon = function (className, switcherIcon, showLine, _a) {
    if (className === void 0) { className = ''; }
    var isLeaf = _a.isLeaf, expanded = _a.expanded, loading = _a.loading;
    if (loading) {
        return (_jsx(CircularProgress, { size: 15, color: "inherit", thickness: 5, sx: { opacity: 0.5 }, className: "rc-tree-switcher-loading-icon" }));
    }
    if (isLeaf) {
        return showLine ? (_jsx(InsertDriveFileOutlinedIcon, { className: clsx('rc-tree-switcher-noop', className) })) : null;
    }
    var switcherCls = "rc-tree-switcher-icon";
    if (isValidElement(switcherIcon)) {
        // @ts-ignore
        return React.cloneElement(switcherIcon, {
            className: clsx(switcherIcon.props
                .className || '', switcherCls),
        });
    }
    if (switcherIcon) {
        return switcherIcon;
    }
    if (showLine) {
        return expanded ? (_jsx(IndeterminateCheckBoxOutlinedIcon, { className: clsx('rc-tree-switcher-line-icon', className) })) : (_jsx(AddBoxOutlinedIcon, { className: clsx('rc-tree-switcher-line-icon', className) }));
    }
    return _jsx(ExpandMoreIcon, { className: switcherCls });
};
export default renderSwitcherIcon;
